// http://css-tricks.com/snippets/javascript/htmlentities-for-javascript/
export default function stripHtml(str: unknown) {
  return str ? String(str).replace(/(<([^>]+)>)/gi, '') : '';
}
